/* eslint-disable react/button-has-type */
import React from "react";
import PropTypes from "prop-types";
import "../styles/button-container.scss";
import Spinner from "./spinner";

function Button(props) {
  const { label, type, className, onClick, disabled, isSubmitting } = props;

  return (
    <button
      type={type}
      className={className}
      disabled={disabled}
      onClick={onClick}
    >
      {!isSubmitting ? <span>{label}</span> : <Spinner size="sm" />}
    </button>
  );
}

Button.defaultProps = {
  type: "button",
  className: "",
  isSubmitting: false,
  disabled: false,
  onClick: () => {}
};

Button.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Button;
